module.exports = {
  "/": {
    "success": {
      "third party call loaded": [
        "THIRD_PARTY_LOAD"
      ],
      "provider menu loaded": [
        "PROVIDER_MENU_LOAD"
      ],
      "first party call loaded": [
        "FIRST_PARTY_LOAD"
      ]
    }
  }
};